import { Close } from "@material-ui/icons";
import "bootstrap-daterangepicker/daterangepicker.css";
import React from "react";
import { Col, Button, Nav, Row, Tab } from "react-bootstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import UrlConstants from "../../../config/UrlConstants";
import { getBuyerAgentMasterTemplateAction } from "./../../../actions/BuyerAgentMasterTemplateActions";
import {
  changeTransactionStatusAction,
  getTransactionDataAction,
  getAllTasksAction,
} from "./../../../actions/TransactionActions";
import { getContactsActions } from "../../../actions/UserActions";
import { getSubscriptionCounterAction } from "./../../../actions/SubscriptionReportAction";
import placeholderImage from "./../../../assets/img/property-placeholder.jpg";
import { cryptoTokenDecode } from "./../../Common/Common";
import * as message from "./../../../config/CommonMessages";
import { REACT_APP_CRYPTO_SECRET_KEY } from "../../../config/Constants";
import ViewContact from "./../ViewContact";
import UserPersonalDocuments from "./../../UserPersonalDocuments/Documents";
import { IconButton } from "@material-ui/core";

var CryptoJS = require("crypto-js");

class Detail extends React.Component {
  constructor(props) {
    super(props);
    let userType = cryptoTokenDecode().usertype;
    let currentType = cryptoTokenDecode().roleName;

    this.state = {
      ownerId: "",
      userType: userType.toUpperCase(),
      currentRole: !!currentType ? currentType.toUpperCase() : "",
      activeKey: "first",

      permissionArray: [],
    };
  }

  componentWillMount() {
    this.getUserPermissions();
  }

  componentDidMount() {
    if (this.props.tab === "1") {
      this.setState({ activeKey: "first" });
    }
    if (this.props.tab === "2") {
      this.setState({ activeKey: "second" });
    }
  }

  getUserPermissions() {
    let usertype = localStorage.getItem("usertype");
    if (usertype === message.VENDOR) {
      let permission = localStorage.getItem("otherInfo");
      let permissionarray;
      if (permission) {
        let bytes = CryptoJS.AES.decrypt(
          permission,
          REACT_APP_CRYPTO_SECRET_KEY
        );
        let decryptedData = bytes.toString(CryptoJS.enc.Utf8);
        permissionarray = decryptedData.split(",");
        this.setState({ permissionArray: permissionarray });
      }
    }
  }

  checkPermission(checkFor) {
    let usertype = localStorage.getItem("usertype");
    if (usertype === message.ACCTOWNER) {
      return true;
    } else {
      const hasSome =
        this.state.permissionArray &&
        this.state.permissionArray.length > 0 &&
        checkFor.some((item) => this.state.permissionArray.includes(item));
      return hasSome;
    }
  }

  onTrigger = (event) => {
    // Call the parent callback function
    this.props.parentCallback();
    event.preventDefault();
  };

  render() {
    return (
      <div>
        <Tab.Container
          id="left-tabs-example"
          defaultActiveKey="first"
          activeKey={this.state.activeKey}
          onSelect={(k) => {
            this.setState({ activeKey: k });
          }}
          mountOnEnter={true}
          unmountOnExit={true}
          forceRenderTabPanel={true}
        >
          <Row className="ml-0 mr-0 page-head-row page-head-row-big align-items-center">
            <Col xs="12" sm="3">
              <div className="trans-combo align-items-center">
                <div className="trans-img">
                  <img
                    src={
                      this.props.contactData &&
                      this.props.contactData.UserData[0] &&
                      this.props.contactData.UserData[0].avatar &&
                      this.props.contactData.UserData[0].avatar !== "-"
                        ? UrlConstants.AdminCreateTransactionUrl +
                          "/upload?id=" +
                          this.props.contactData.contactId +
                          "&img=" +
                          this.props.contactData.UserData[0].avatar
                        : placeholderImage
                    }
                    alt="user"
                  />
                </div>
                <div className="trans-info">
                  <h5 style={{ color: "white", fontWeight: "bold" }}>
                    {this.props.contactData.UserData[0].firstname +
                      (this.props.contactData.UserData[0].lastname
                        ? " " + this.props.contactData.UserData[0].lastname
                        : "")}
                  </h5>
                </div>
              </div>
            </Col>

            <Col xs="12" sm="6">
              <Nav className="justify-content-center align-items-end trans-tabs">
                <Nav.Item>
                  <Nav.Link eventKey="first">View</Nav.Link>
                </Nav.Item>
                {this.state.userType === message.ACCTOWNER && (
                  <Nav.Item>
                    <Nav.Link eventKey="second">Documents</Nav.Link>
                  </Nav.Item>
                )}
              </Nav>
            </Col>

            <Col xs="12" sm="3">
              <div className="d-flex justify-content-end align-items-center switch-div">
                <IconButton onClick={this.onTrigger}>
                  <Close
                    style={{
                      stroke: "#fff",
                      height: "40px",
                      width: "40px",
                    }}
                  />
                </IconButton>
              </div>
            </Col>
          </Row>
          <div className="trans-tab-content">
            <Tab.Content>
              <Tab.Pane eventKey="first">
                <ViewContact
                  contactData={this.props.contactData}
                  roleForPopup={this.props.roleForPopup}
                />
              </Tab.Pane>
              {this.state.userType === message.ACCTOWNER && (
                <Tab.Pane eventKey="second">
                  <UserPersonalDocuments contactData={this.props.contactData} />
                </Tab.Pane>
              )}
            </Tab.Content>
          </div>
        </Tab.Container>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps, {
  getTransactionDataAction,
  changeTransactionStatusAction,
  getBuyerAgentMasterTemplateAction,
  getAllTasksAction,
  getSubscriptionCounterAction,
  getContactsActions,
})(Detail);
